import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const sitemapLinks = [
    {
      titleKey: "footer.categories.booking",
      links: [
        { key: "footer.links.yokohama", href: "/yokohama" },
        { key: "footer.links.pricing", href: "/pricing" },
        { key: "footer.links.gift", href: "/gift" },
        { key: "footer.links.firstTime", href: "/first-time" },
      ],
    },
    {
      titleKey: "footer.categories.guide",
      links: [
        { key: "footer.links.faq", href: "/faq" },
        { key: "footer.links.access", href: "/access" },
        { key: "footer.links.baggage", href: "/baggage" },
        { key: "footer.links.flow", href: "/flow" },
        { key: "footer.links.bookingFlow", href: "/booking-flow" },
        { key: "footer.links.cancelPolicy", href: "/cancel-policy" },
      ],
    },
    {
      titleKey: "footer.categories.about",
      links: [
        { key: "footer.links.company", href: "/company" },
        { key: "footer.links.column", href: "/column" },
        { key: "footer.links.reviews", href: "/reviews" },
        { key: "footer.links.news", href: "/news" },
      ],
    },
    {
      titleKey: "footer.categories.support",
      links: [
        { key: "footer.links.contact", href: "/contact" },
        { key: "footer.links.privacy", href: "/privacy" },
        { key: "footer.links.tokushoho", href: "/tokushoho" },
        { key: "footer.links.sitemap", href: "/sitemap" },
      ],
    },
  ];

  return (
    <footer className="bg-airdoa-navy text-white/80">
      <div className="px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src="https://storage.readdy-site.link/project_files/c1f8e568-4952-4e6e-ba0d-4132aeaff1e6/b034907f-f499-43dd-a4b8-521068ddd260_AIRDOA.png?v=c470717b8f4d46fdaf3346483a6a693b"
                alt="AIRDOA"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-sm text-white/60 leading-relaxed whitespace-pre-line">
              {t("footer.tagline")}
            </p>
          </div>

          {sitemapLinks.map((group) => (
            <div key={group.titleKey}>
              <h4 className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-5">
                {t(group.titleKey)}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-white/70 hover:text-white transition-colors duration-200"
                    >
                      {t(link.key)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy"
              className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200"
            >
              {t("footer.privacy")}
            </Link>
            <Link
              to="/tokushoho"
              className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200"
            >
              {t("footer.tokushoho")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
